import { useContext, useState } from 'react';
import {
  Box,
  alpha,
  Stack,
  lighten,
  Divider,
  IconButton,
  styled,
  useTheme,
  Typography,
  Button,
  useMediaQuery,
  Tooltip
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import HeaderUserbox from './Userbox';
import { usePanelName } from 'src/components/PageHeader/PanelNameProvider';
import AssessmentModal from 'src/components/AssessmentModal';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { Book } from '@mui/icons-material';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        
`
);

function Header({ collapsed }) {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { panelName } = usePanelName();
  const theme = useTheme();
  const LoginUserInfo = useSelector((state: RootState) => state?.auth?.user);

  const userType = LoginUserInfo?.userType;
  console.log(userType, 'userrrtypee');
  const [handleModal, setHandleModal] = useState(false);
 
 const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleModalOpen = () => {
    setHandleModal(true);
  };

  const handleModalClose = () => {
    setHandleModal(false);
    window.location.reload()

  };
  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        padding: '10px',
        left: {
          lg: collapsed ? '80px' : '273px'
        },
        width: {
          lg: 'auto',
          xs: '100%'
        },

        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`
      }}
    >
      <Box display="flex" alignItems="center">
        <Box
          component="span"
          sx={{
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <IconButton color="primary" onClick={toggleSidebar}>
            {!sidebarToggle ? (
              <MenuTwoToneIcon fontSize="medium" />
            ) : (
              <CloseTwoToneIcon fontSize="small" />
            )}
          </IconButton>
        </Box>
        {/* <Stack ml={1} divider={<Divider orientation="vertical" flexItem />}>
          <Typography fontWeight={'medium'} fontSize={18} color={'#01011A'}>
            {panelName}
          </Typography>
          <Typography fontSize={12} color={'#39557E'} fontWeight={'medium'}>
            Here You Can See the {panelName} details
          </Typography>
        </Stack> */}
      </Box>

      <Box display="flex" alignItems="center">
      {userType === 'TEACHER' && 
        
<Tooltip 
  title="Request Assessment" 
  arrow 
  sx={{
    '& .MuiTooltip-tooltip': {
      backgroundColor: 'black', 
      color: 'white', 
      fontSize: '14px' 
    }
  }}
>
  <Box
    onClick={handleModalOpen}
    sx={{
      cursor: 'pointer',
     display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 50,
      height:50,
      mr: 2
    }}
  >
    <img
      src="/req.svg"
      alt="Request Assessment"
      width={35}
      height={35}
    />
  </Box>
</Tooltip>
}
   

        <HeaderUserbox />
      </Box>
      {handleModal && <AssessmentModal handleClose={handleModalClose} />}
    </HeaderWrapper>
  );
}

export default Header;
